"use strict";
/**
 * trsHight Module
 *
 * Description
 */
angular.module('trsHeightsModule', []).directive('trsHeights', ['$window', '$parse', '$timeout', function ($window, $parse, $timeout) {
    return {
        restrict: 'EA',
        link: function (scope, iElement, iAttrs) {
            $timeout(function () {
                contentHeigth();
            });

            function contentHeigth() {
                var windowHeight = window.innerHeight;
                var fixHeight = !isNaN(iAttrs["fixheight"]) ? Number(iAttrs["fixheight"]) : 0;
                var parentsiblings = isNaN(iAttrs["parentsiblings"]) ? iAttrs["parentsiblings"] : false;
                var isheight = isNaN(iAttrs["isheight"]) ? iAttrs["isheight"] : false;
                var position = isNaN(iAttrs["position"]) ? iAttrs["position"] : false;
                var parentHeight = 0;
                if (parentsiblings) {
                    var $parentSiblings = iElement.parent().siblings();
                    $parentSiblings.each(function (index, el) {
                        parentHeight += $(this).height();
                    });

                }
                $timeout(function () {
                    if (position) {
                        iElement.css({
                            "position": 'relative',
                            "overflow": 'auto'
                        })
                    }
                    if(isheight){
                        iElement.css({
                            "height": windowHeight - (fixHeight + parentHeight)
                        })
                    }else{
                        iElement.css({
                            "max-height": windowHeight - (fixHeight + parentHeight)
                        })
                    }
                });
            }
            window.addEventListener("resize", resize);
            scope.$on("$destroy", function () {
                window.removeEventListener("resize", resize);
            });
            /**
             * [resize description] 重置高度
             * @return {[type]} [description]
             */
            function resize() {
                contentHeigth();
            }
        }
    };
}]);